import { IconLayer } from "@deck.gl/layers";
import { LineString } from "geojson";
import { useMemo } from "react";
import { useSelector } from "react-redux";

import { getLayers } from "../../state/layerOneDMenu";
import { getSelectedAsset } from "../../state/selectedAsset";
import { Asset } from "../../types/assets";

import { UseArrowLayer } from "./arrow/ArrowLayer";
import { getLayerColors } from "./DeckGlConsts";

const usePumpArrowLayer = (assets?: { [value: string]: Asset[] }): IconLayer[] => {
  const oneDLayersStyle = useSelector(getLayers);
  const selectedAsset = useSelector(getSelectedAsset);
  const COLORS = getLayerColors(oneDLayersStyle);

  const convertToLinestrings = (assets: Asset[]) => {
    return assets
      .map((d) => {
        const lineGeometry = "line_geometry" in d.properties && d.properties.line_geometry;
        if (!lineGeometry) return;
        const { coordinates } = lineGeometry;

        return {
          ...lineGeometry,
          coordinates: [
            [coordinates[0], coordinates[1]],
            [coordinates[2], coordinates[3]],
          ],
        };
      })
      .filter((d): d is LineString => !!d);
  };

  const lineStringsStatic = useMemo(() => {
    if (!assets || !assets.pumps) return [];
    return convertToLinestrings(assets.pumps);
  }, [assets]);

  const lineStringsSelected = useMemo(() => {
    if (!selectedAsset) return [];
    return convertToLinestrings([selectedAsset]);
  }, [selectedAsset]);

  const defaultArrows = UseArrowLayer({
    id: "deckgl-pump-arrow-layer",
    data: lineStringsStatic,
    getColor: COLORS.WHITE,
    visible: oneDLayersStyle.pumps.visible,
  });

  const selectedArrows = UseArrowLayer({
    id: "deckgl-pump-arrow-layer-selected",
    data: lineStringsSelected,
    getColor: COLORS.SELECTED,
    visible: oneDLayersStyle.pumps.visible,
  });

  if (!assets) return [];

  return [defaultArrows, selectedArrows];
};

export default usePumpArrowLayer;
